import { userProfileApi } from "@/lib/api"
import { useQuery } from "@tanstack/react-query"

const useGetPreferences = () => {
  return useQuery({
    queryKey: [useGetPreferences.QUERY_KEY],
    queryFn: async () => {
      const response = await userProfileApi.getSystemPreferences()
      return response.data.data
    },
  })
}

useGetPreferences.QUERY_KEY = "system-preferences"

export default useGetPreferences
